<template>
  <div class="mx-4">
    <el-tabs v-model="activeName">
      <el-tab-pane label="主信息" name="base">
        <InfoMain :formData="formData" />
      </el-tab-pane>
      <el-tab-pane label="同步数据" name="request">
        <InfoSync :formData="formData" />
      </el-tab-pane>
      <el-tab-pane label="推送数据" name="response">
        <InfoPush :formData="formData" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import InfoMain from './info-main'
import InfoSync from './info-sync'
import InfoPush from './info-push'
export default {
  components: { InfoMain, InfoSync, InfoPush },
  props: { syncCode: { type: String, default: '' } },
  data() {
    return { formData: {}, activeName: 'base' }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.syncCode) return
      this.$api
        .sysOpenapiSynclogDetailApi({
          syncCode: this.syncCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
  },
}
</script>
